import { ParamMap } from '@angular/router';
import { common_urls } from 'src/environments/environment';
import { StpScreenType } from './side-nav-config/stp.config';

export class CwsUrlNavigator {

  static id: string;
  static policyNumber: string;
  static sProdCd: string;
  static lProdCd: string | null;
  static authUser: boolean = false;
  static screenType: string | null = null; 
  private static get BASE_URL(): string {
    return common_urls.cwsBaseUrl;
  }

  /**
   * Resolves the policy number for a procedure that needs it: prefers the destination
   * route's own `polNo` query param, falling back to the cached `policyNumber` when absent.
   * @param queryParamMap the destination route's snapshot query param map
   * @returns the policy number, or null if neither source has a value
   */
  static resolvePolicyNumber(queryParamMap: ParamMap): string | null {
    return queryParamMap.get('polNo') || this.policyNumber || null;
  }

  /**
   * Resolves the small product code for a procedure that needs it: prefers the destination
   * route's own `sprodCd` query param, falling back to the cached `sProdCd` when absent.
   * @param queryParamMap the destination route's snapshot query param map
   * @returns the small product code, or null if neither source has a value
   */
  static resolveSProdCd(queryParamMap: ParamMap): string | null {
    return queryParamMap.get('sprodCd') || this.sProdCd || null;
  }

  /**
   * Resolves the large product code for a procedure that needs it: prefers the destination
   * route's own `lprodCd` query param, falling back to the cached `lProdCd` when absent.
   * @param queryParamMap the destination route's snapshot query param map
   * @returns the large product code, or null if neither source has a value
   */
  static resolveLProdCd(queryParamMap: ParamMap): string | null {
    return queryParamMap.get('lprodCd') || this.lProdCd || null;
  }

  static CWS_Navigation_URL(navigatingPage: string, isPolicyInquiry: boolean = false, isId: boolean = false, isUserId: boolean = false, isCws: boolean = false, isAuthUser: boolean = false): string {
    this.authUser = isAuthUser;
    return `${this.BASE_URL}${this.isAuthenticUser}/${navigatingPage}` + this.GENERATE_QUERY_PARAM(isPolicyInquiry, isId, isUserId, isCws);
  }

  static get isAuthenticUser() {
    return this.authUser ? "/apex" : "";
  }

  static GENERATE_QUERY_PARAM(isPolicyInquiry: boolean = false, isId: boolean = false, isUserId: boolean = false, isCws: boolean = false) {
    let queryParams = "";
    queryParams = isPolicyInquiry ? this.QUERY_PARAMS_FROM : "";
    if(this.screenType !== StpScreenType){
      if (isId && this.id != undefined && this.id != '') {
        queryParams += queryParams ? "&" : "";
        queryParams += this.QUERY_PARAMS_ID(this.id);
      }
  
      if (isUserId) {
        queryParams += queryParams ? "&" : "";
        queryParams += this.QUERY_PARAMS_USER_ID;
      }
  
      if (isCws) {
        queryParams += queryParams ? "&" : "";
        queryParams += this.QUERY_PARAMS_CWS;
      }
    }
    return queryParams ? `?${queryParams}` : "";
  }

  static get QUERY_PARAMS_FROM(): string {
    let fromQueryVal:string = "policyinquiry"
    if(this.screenType == StpScreenType)
    fromQueryVal = "home"
    return `from=${fromQueryVal}`;
  }

  static QUERY_PARAMS_ID(id: string): string {
    return `id=${id}`;
  }

  static get QUERY_PARAMS_USER_ID(): string {
    return `userId=`;
  }

  static get QUERY_PARAMS_CWS(): string {
    return `cws=1`;
  }

  static CWS_Home_Navigation(navigatingPage: string){
    return `${this.BASE_URL}/${navigatingPage}?from=home&${this.QUERY_PARAMS_CWS}`;
  }
}
